module.exports = {"available":"Prosto","booked":"Rezervirano","occupied":"Occupied","booked-occupied":"Rezervirano / Occupied","used":"used","until":"do","all-day":"Ves dan","page_over_total":"Stran {page} od {total}","room-name":"Ime sobe","current-booking":"Trenuten","next-booking":"Naslednji","unknown":"Neznano","floors":"Nadstropje","today":"Danes","no_bookings":"Za danes ni načrtovan noben sestanek.","no_information":"Ni podanih informacij.","description":"Description","capacity":"Capacity","allocated":"Allocated","booked-occupied-allocated":"Rezervirano / Occupied / Allocated"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/locales/sl.json
// module id = +W2L
// module chunks = 2